import { recurrenceIntervals, recurrenceTypes } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { objectArrayFromDiffFields } from 'globalutils/fmUtils';
import React, { lazy, useState } from 'react';
import Filters from '../Filters';
import { formatTime, getMappedLabel } from '../utils/helpers';
import SchedulerModal from './SchedulerModal';
import { columns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));

const SchedulerTable = ({
  paginateList,
  hasFetchApiStatus,
  Styled,
  history,
  i18n,
  callback,
  handleDelete,
  reportTypes,
  changeRequest,
  request,
  pagination,
  setPagination,
  handleEdit,
  drivers,
  vehicles,
}) => {
  const [values, setInitialValues] = useState({ type: null });
  const [modalConfig, setModalConfig] = useState({ open: false, edit: false, content: null });

  const reportTypesList = objectArrayFromDiffFields(reportTypes, 'key', 'displayName');

  const handleEditClick = (item) => {
    setModalConfig({
      edit: true,
      open: true,
      content: { item, type: 'edit' },
    });
  };

  const handleDeleteClick = (item) => {
    setModalConfig({
      edit: false,
      open: true,
      content: { item, type: 'delete' },
    });
  };

  const generateRows = (data) =>
    data.map((item) => ({
      ...item,
      reportType: getMappedLabel(reportTypesList, item.type),
      recurrenceType: getMappedLabel(recurrenceTypes, item.recurrenceType),
      recurrenceInterval: getMappedLabel(recurrenceIntervals, item.recurrenceInterval),
      requestDateKey: formatTime(item.requestDate, true),
      nextFireDate: formatTime(item.nextFireDate, true),
      action: (
        <div className="actionBox">
          <Icon src={mediaUrls?.edit} tooltip={i18n.t('common.edit')} onClick={() => handleEditClick(item)} />
          <Icon src={mediaUrls?.deleteIcon} tooltip={i18n.t('common.delete')} onClick={() => handleDeleteClick(item)} />
        </div>
      ),
    }));

  const emptyMessage = hasFetchApiStatus?.errorMessage ? (
    <Message type="error" message={hasFetchApiStatus.errorMessage} />
  ) : (
    'common.tableEmptyMessage'
  );

  return (
    <Styled.Wrapper>
      <div className="quickFilter"></div>
      <div className="tableWrapper">
        <Filters
          reportTypesList={reportTypesList}
          filterList={changeRequest}
          handleReset={() => changeRequest({ type: null })}
          values={values}
          setInitialValues={setInitialValues}
        />

        <Table
          type="server"
          defaultSortBy={{ sortBy: 'full_name', order: 'desc' }}
          title=""
          changeRequest={changeRequest}
          baseRequest={request}
          totalRecords={paginateList?.totalElements}
          columns={[...columns]}
          data={generateRows(paginateList?.content || [])}
          emptyMessage={emptyMessage}
          itemsPerPage={15}
          pageinationReset={pagination}
          actions={[]}
          i18n={i18n}
          pagenationClicked={(e) => {
            setPagination(!e);
          }}
        />

        <SchedulerModal
          config={modalConfig}
          setModalConfig={setModalConfig}
          reportTypesList={reportTypesList}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          callback={callback}
          Styled={Styled}
          drivers={drivers}
          vehicles={vehicles}
          history={history}
          i18n={i18n}
        />
      </div>
    </Styled.Wrapper>
  );
};

export default SchedulerTable;
